import { createSlice } from "@reduxjs/toolkit";
import { getDashboardData, getStats } from "./actions";

const initialState = {
  loading: false,
  data: [],
  stats: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getStats.fulfilled, (state, { payload }) => ({
        ...state,
        stats: payload,
      }))
      .addCase(getDashboardData.fulfilled, (state, { payload }) => ({
        ...state,
        data: payload,
      }));
  },
});

export default dashboardSlice.reducer;
